import { render, staticRenderFns } from "./SipTrunk.vue?vue&type=template&id=23f37c3c&scoped=true"
import script from "./SipTrunk.vue?vue&type=script&lang=js"
export * from "./SipTrunk.vue?vue&type=script&lang=js"
import style0 from "./SipTrunk.vue?vue&type=style&index=0&id=23f37c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f37c3c",
  null
  
)

export default component.exports